var render = function render(){var _vm=this,_c=_vm._self._c;return _c('process-directory',{attrs:{"type":5,"title":"Recuperações extrajudiciais","route-base":"/recuperacao-extrajudicial"}})
}
var staticRenderFns = []

export { render, staticRenderFns }